import React from "react";
import { Grid2 } from "@mui/material";
import { useTranslation } from "react-i18next";

import { projectCardIcons } from "./model/constants";
import { ProjectCard } from "./ProjectCard/ProjectCard";

type ProjectCardData = { title: string; description: string };

export const ProjectCards: React.FC = () => {
  const { t } = useTranslation();
  const projectCardsMock = (
    t("projects.cards", { returnObjects: true }) as ProjectCardData[]
  ).map((card, index) => ({ ...card, icon: projectCardIcons[index] }));

  return (
    <Grid2
      container
      columns={{ xs: 3 }}
      spacing={4}
      direction="row"
      alignItems="stretch"
    >
      {projectCardsMock.map((projectCard) => (
        <ProjectCard
          key={projectCard.title}
          title={projectCard.title}
          description={projectCard.description}
          icon={projectCard.icon}
        />
      ))}
    </Grid2>
  );
};
